import React, { Suspense } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import Protectedroute from "./Maincomponent/Protectedroute";
import Accountsexecutive from "./pages/customerenquiry/Accountsexecutive";
const Main = React.lazy(() => import("./main"));
const Login = React.lazy(() => import("./pages/login/login"));
const CustomerEnquiryform = React.lazy(() =>
  import("./pages/customerenquiry/customerEnquiry")
);
const Newform = React.lazy(() => import("./pages/customerenquiry/Newform"));
const ThankYouPage = React.lazy(() =>
  import("./pages/customerenquiry/Thankyou")
);

const App = () => {
  return (
    <Router>
      <Suspense fallback={<div style={{ padding: 30 }}>Loading...</div>}>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/thank-you" element={<ThankYouPage />} />
          <Route path="/thank-you-page" element={<ThankYouPage />} />
          <Route path="/thank-you-page1" element={<ThankYouPage />} />
          <Route
            path="/candidate-form"
            element={<CustomerEnquiryform />}
          />

          <Route
            path="/sales-executive-form"
            element={<Newform />}
          />
          <Route
            path="/customer-support-form"
            element={<Newform imgstring={"customersupport"} />}
          />
 <Route
            path="/accounts-executive-form"
            element={<Accountsexecutive />}
          />
          <Route
            path="/"
            element={
              <Protectedroute>
                <Main />
              </Protectedroute>
            }
          />
        </Routes>
      </Suspense>

      <Toaster />
    </Router>
  );
};

export default App;